module.exports = __webpack_public_path__ + "media/images/offered-payment-plan-step-1-b971ce7d.png";